import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, Easing } from "remotion";
import { loadFont } from "@remotion/google-fonts/NotoSansDevanagari";
import { loadFont as loadInter } from "@remotion/google-fonts/Inter";
import strokeData from "../public/kedarnath/strokes.json";

const { fontFamily: devFont } = loadFont("normal", { weights: ["700"], subsets: ["devanagari"] });
const { fontFamily: inter } = loadInter("normal", { weights: ["400", "600"], subsets: ["latin"] });

const GOLD  = "#FFD700";
const N_LAYERS = 12;
// Each layer gets a draw window; layers draw bottom→top
const DRAW_START = 0.5;   // seconds
const LAYER_STEP = 0.35;  // seconds between layers
const STROKE_DUR = 0.55;  // seconds to draw each layer's paths

export const KedarnathEndCard: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const f = (s: number) => Math.round(s * fps);
  const total = f(10);

  const bgIn   = interpolate(frame, [0, f(0.3)], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const fadeOut = interpolate(frame, [total - f(1.0), total], [1, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  const drawEnd = DRAW_START + N_LAYERS * LAYER_STEP + STROKE_DUR;

  // Glow pulse after all paths drawn
  const glowT = Math.max(0, frame / fps - drawEnd);
  const glowPulse = Math.sin(glowT * 0.25) * 0.3 + 0.7;

  // Text timing
  const textStart = drawEnd + 0.6;
  const hindiOp = interpolate(frame, [f(textStart), f(textStart + 1.0)], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const hindiY  = interpolate(hindiOp, [0, 1], [16, 0]);
  const subOp   = interpolate(frame, [f(textStart + 1.3), f(textStart + 2.0)], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  // Precompute per-layer dashoffset (0=fully drawn, 1=hidden)
  const layerProgress = Array.from({ length: N_LAYERS }, (_, l) => {
    const layerStart = f(DRAW_START + l * LAYER_STEP);
    const layerEnd   = f(DRAW_START + l * LAYER_STEP + STROKE_DUR);
    return interpolate(frame, [layerStart, layerEnd], [1, 0], {
      extrapolateLeft: "clamp", extrapolateRight: "clamp",
      easing: Easing.bezier(0.16, 1, 0.3, 1),
    });
  });

  const filterVal = glowT > 0
    ? `drop-shadow(0 0 ${4 + glowPulse * 8}px rgba(255,215,0,${0.2 + glowPulse * 0.2}))`
    : "none";

  return (
    <AbsoluteFill style={{ background: "#07090e", opacity: bgIn * fadeOut }}>

      {/* Stars */}
      <AbsoluteFill>
        {Array.from({ length: 55 }, (_, i) => (
          <div key={i} style={{
            position: "absolute",
            left: `${(i * 173.7 + 11) % 100}%`,
            top:  `${(i * 97.3 + 7) % 72}%`,
            width: i % 5 === 0 ? 2 : 1, height: i % 5 === 0 ? 2 : 1,
            borderRadius: "50%", background: "#fff",
            opacity: 0.07 + (i % 7) * 0.05,
          }} />
        ))}
      </AbsoluteFill>

      {/* Temple stroke-draw SVG */}
      <div style={{
        position: "absolute", inset: 0,
        display: "flex", alignItems: "center", justifyContent: "center",
        paddingBottom: 100,
      }}>
        <svg
          viewBox="0 0 920 714"
          width={920} height={714}
          style={{ filter: filterVal, overflow: "visible" }}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {(strokeData as Array<{l: number; d: string}>).map((p, i) => {
            const progress = layerProgress[p.l];
            return (
              <path
                key={i}
                d={p.d}
                stroke={GOLD}
                strokeWidth={1.6}
                strokeOpacity={0.9}
                pathLength={1}
                strokeDasharray={1}
                strokeDashoffset={progress}
              />
            );
          })}
        </svg>
      </div>

      {/* Text */}
      <div style={{
        position: "absolute", bottom: 36, left: 0, right: 0,
        display: "flex", flexDirection: "column", alignItems: "center", gap: 14,
      }}>
        <div style={{
          opacity: hindiOp,
          transform: `translateY(${hindiY}px)`,
          fontFamily: devFont, fontSize: 62, fontWeight: 700,
          color: GOLD, lineHeight: 1,
          textShadow: "0 2px 32px rgba(255,215,0,0.55)",
        }}>
          हर हर महादेव
        </div>
        <div style={{
          opacity: subOp, fontFamily: inter, fontSize: 12, fontWeight: 600,
          color: "rgba(255,255,255,0.42)", letterSpacing: 8, textTransform: "uppercase",
        }}>
          Har Har Mahadev
        </div>
      </div>

    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
